(() => {
  const setup = (scope = document) => {
    const pages = scope.matches?.('[data-gb-editorial]') ? [scope] : scope.querySelectorAll('[data-gb-editorial]');
    pages.forEach((page) => {
      if (page.dataset.gbEditorialReady) return;
      page.dataset.gbEditorialReady = 'true';
      // Content is visible by default: no network or script delay can hide a section.
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('gb-ed-is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.12 });
        page.querySelectorAll('[data-gb-ed-reveal]').forEach((element) => observer.observe(element));
      }
      // Keep native details/summary semantics and keyboard operation intact.
      page.querySelectorAll('.gb-ed-faq').forEach((detail) => {
        detail.addEventListener('toggle', () => {
          if (!detail.open) return;
          detail.parentElement.querySelectorAll('.gb-ed-faq[open]').forEach((sibling) => {
            if (sibling !== detail) sibling.open = false;
          });
        });
      });
      const status = page.querySelector('.gb-ed-form-status');
      if (status && window.location.hash === '#GbProfessionalContactForm') {
        status.setAttribute('tabindex', '-1');
        status.focus({ preventScroll: true });
      }
    });
  };
  setup();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
